(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'MyTripsAccountEmergencyContact',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load($form)
	{
		$("#mytripsaccountemergencycontact-emergency_contact_relationship").on('change', function toggleRelationshipOther(e)
		{
			var relationship = $(this).val();

			if (relationship === 'Other') {
				$(".emergency-contact-relationship-other").removeClass('hidden');
			} else {
				$(".emergency-contact-relationship-other").addClass('hidden');
			}
		});
	};

}(jQuery, window.Adzuki || {}));
